var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOval(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.845 62.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.151 14.52 27.151 10.351 23.816 14.52 27.151 14.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.151 14.52 31.57 14.52 28.151 10.246 28.151 14.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.559,30.449H9.791l4.617-5.771V15.2l-3.432-4.29A33.043,33.043,0,0,0,4.559,30.449Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40.976 30.449 44.312 30.449 40.976 26.278 40.976 30.449"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.408,46.7V37.323l-4.7-5.874H4.559a33.04,33.04,0,0,0,6.417,19.542Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.408 30.449 14.408 26.279 11.072 30.449 14.408 30.449"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40.976 31.449 40.976 35.722 44.395 31.449 40.976 31.449"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.408 31.449 10.989 31.449 14.408 35.722 14.408 31.449"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.151,1.963V8.646l4.7,5.874h7.3L43.687,10.1C39.641,5.2,34.178,2.125,28.151,1.963Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.151,59.935V53.25l-4.616-5.769H15.066L11.614,51.8C15.66,56.7,21.124,59.773,27.151,59.935Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.151 47.481 23.816 47.481 27.151 51.65 27.151 47.481"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.148,14.52h7.387l4.616-5.769V1.962c-6.027.162-11.491,3.232-15.537,8.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.235,47.481H32.851l-4.7,5.874v6.58c6.027-.162,11.49-3.232,15.536-8.139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.743,31.449H45.676l-4.7,5.875v9.481l3.349,4.186A33.032,33.032,0,0,0,50.743,31.449Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.976,15.092v9.585l4.618,5.772h5.149a33.032,33.032,0,0,0-6.418-19.542Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.151 47.481 28.151 51.754 31.57 47.481 28.151 47.481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.65.947c-13.29,0-24.1,13.459-24.1,30s10.811,30,24.1,30,24.1-13.459,24.1-30S40.94.947,27.65.947ZM23.016,46.481l-7.608-9.509V25.029l7.608-9.509H32.37l7.606,9.508V36.972L32.37,46.481ZM15.408,15.52h6.327l-6.327,7.908Zm-1,14.929H11.072l3.336-4.17Zm0,1v4.273l-3.419-4.273Zm1,7.124,6.327,7.908H15.408ZM39.976,23.427,33.651,15.52h6.325Zm0,15.147v7.907H33.651Zm1-7.125H44.4l-3.419,4.273Zm0-1V26.278l3.336,4.171ZM28.151,14.52V10.246L31.57,14.52Zm-1,0H23.816l3.335-4.169ZM14.408,24.678,9.791,30.449H4.559a33.043,33.043,0,0,1,6.417-19.543l3.432,4.29Zm-4.7,6.771,4.7,5.874V46.7l-3.432,4.29A33.04,33.04,0,0,1,4.559,31.449ZM27.151,47.481V51.65l-3.335-4.169Zm1,0H31.57l-3.419,4.273ZM40.976,37.324l4.7-5.875h5.067a33.032,33.032,0,0,1-6.418,19.542l-3.349-4.186Zm4.618-6.875-4.618-5.772V15.092l3.349-4.185a33.032,33.032,0,0,1,6.418,19.542ZM40.153,14.52h-7.3l-4.7-5.874V1.963c6.027.162,11.49,3.232,15.536,8.139Zm-13-12.558V8.751L22.535,14.52H15.148L11.614,10.1C15.66,5.194,21.124,2.124,27.151,1.962ZM15.066,47.481h7.469l4.616,5.769v6.685C21.124,59.773,15.66,56.7,11.614,51.8ZM28.151,59.935v-6.58l4.7-5.874h7.384L43.687,51.8C39.641,56.7,34.178,59.773,28.151,59.935Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.976 36.972 39.976 25.028 32.37 15.52 23.016 15.52 15.408 25.029 15.408 36.972 23.016 46.481 32.37 46.481 39.976 36.972"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.651 15.52 39.976 23.427 39.976 15.52 33.651 15.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.735 46.481 15.408 38.573 15.408 46.481 21.735 46.481"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.735 15.52 15.408 15.52 15.408 23.428 21.735 15.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.976 46.481 39.976 38.574 33.651 46.481 39.976 46.481"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOval);
export default __webpack_public_path__ + "static/media/oval.2f73d92671be0df4dd28ad924199c539.svg";
export { ForwardRef as ReactComponent };